function getMainRawValue(address) {
  if (!address || typeof address !== "object") return undefined;

  return (
    address.main ??
    address.isDefault ??
    address.is_default ??
    address.default ??
    address.defaultAddress
  );
}

export function isMainAddress(address) {
  const value = getMainRawValue(address);

  if (value === true || value === 1 || value === "1") return true;
  if (value === false || value === 0 || value === "0" || value == null) {
    return false;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (
      normalized === "false" ||
      normalized === "nao" ||
      normalized === "não" ||
      normalized === "n" ||
      normalized === "no"
    ) {
      return false;
    }
    return normalized === "true" || normalized === "sim" || normalized === "s" || normalized === "y";
  }

  return Boolean(value);
}

export function isFixedAddress(address) {
  const value = address?.fixed;
  return value === 1 || value === "1" || value === true;
}

export function normalizeAddressFromApi(address) {
  if (!address || typeof address !== "object") return address;

  return {
    ...address,
    main: isMainAddress(address),
    fixed: isFixedAddress(address) ? 1 : address.fixed ?? 0,
  };
}

export function mergeSavedAddressMain(addresses, addressUuid, main) {
  if (!Array.isArray(addresses) || !addressUuid) return addresses;

  const normalizedMain = isMainAddress({ main });

  return addresses.map((addr) =>
    addr.uuid === addressUuid
      ? normalizeAddressFromApi({ ...addr, main: normalizedMain })
      : addr,
  );
}

export function extractSavedAddressFromResponse(response) {
  const payload = response?.data?.data;

  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return null;
  }

  return normalizeAddressFromApi(payload);
}

export const SAFRA_FIXED_ADDRESS_MESSAGE =
  "Este é seu endereço de cadastro no Safra. Para alterá-lo é necessário entrar em contato com o banco.";
